import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight, Mail } from "lucide-react";

const CTA_IMG =
  "https://images.unsplash.com/photo-1768508949921-9ef52e81bf1b?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function CtaBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} className="relative py-24 sm:py-36 overflow-hidden bg-royal-deep">
      <motion.div style={{ y: imgY, scale: 1.15 }} className="absolute inset-0" aria-hidden="true">
        <img src={CTA_IMG} alt="" className="h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-royal-deep via-royal-deep/75 to-royal-deep" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cta-band-heading"
          className="font-display text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-white leading-[1.05]"
        >
          Have a project <span className="text-gold-bright">in mind?</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-5 text-sm sm:text-lg text-white/80"
        >
          Tell us what you are planning. We&rsquo;ll take it from there.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, delay: 0.18 }}
          className="mt-10 flex flex-wrap items-center justify-center gap-4"
        >
          <a
            href="#enquiry"
            data-testid="cta-band-request-proposal"
            className="group inline-flex items-center gap-2.5 rounded-full bg-gold px-8 py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-gold-bright hover:shadow-[0_0_40px_rgba(224,19,39,0.5)]"
          >
            Request a Proposal
            <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            href="mailto:zeba@enersider.com"
            data-testid="cta-band-email-link"
            className="inline-flex items-center gap-2.5 rounded-full border border-white/30 px-8 py-4 text-sm font-semibold text-white transition-all duration-300 hover:border-gold-bright hover:text-gold-bright"
          >
            <Mail size={16} />
            zeba@enersider.com
          </a>
        </motion.div>
      </div>
    </section>
  );
}
